import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center self-stretch gap-md gap-md-20"
}
const _hoisted_2 = {
  key: 2,
  class: "relative-position"
}
const _hoisted_3 = {
  key: 0,
  class: "LandingListHeader__filters-count absolute bg-space-b-100 flex flex-center rounded-16"
}
const _hoisted_4 = { class: "text-static-light fs-13px fw-500" }
const _hoisted_5 = {
  key: 0,
  class: "q-mb-sm"
}
const _hoisted_6 = { class: "row items-center gap-xs no-wrap bg-off-white-10 rounded-8 q-py-xs q-px-sm" }
const _hoisted_7 = { class: "row items-center gap-xs" }
const _hoisted_8 = {
  key: 0,
  class: "fs-11px fw-500 text-cool-gray-100 q-mr-xs"
}
const _hoisted_9 = { class: "fs-11px fw-500 text-cool-gray-100" }

import { Ref, ref } from 'vue'
import LandingListFilters, { IFilterData, IFilterObj } from './LandingListFilters.vue'
import { IFilter, IFilterModel } from 'src/common/interfaces'

interface IProps {
  label: string
  disable?: boolean
  rootClass?: string
  hasSearch?: boolean
  hasViewMode?: boolean
  hasFilter?: boolean
  filters?: IFilter[]
  filterModel?: IFilterModel
}

type Emits = { filter: [filter: IFilterModel] }

interface ILandingListFiltersComponent {
  resetFilters: () => void
  resetFilterByKey: (key: string) => void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LandingListHeader', inheritAttrs: false },
  __name: 'LandingListHeader',
  props: /*@__PURE__*/_mergeModels({
    label: {},
    disable: { type: Boolean, default: false },
    rootClass: { default: 'bg-white' },
    hasSearch: { type: Boolean, default: true },
    hasViewMode: { type: Boolean, default: false },
    hasFilter: { type: Boolean, default: true },
    filters: { default: () => [] },
    filterModel: { default: () => ({}) }
  }, {
    "search": { type: String, default: '' },
    "searchModifiers": {},
    "cardViewMode": { type: Boolean, default: false },
    "cardViewModeModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["filter"], ["update:search", "update:cardViewMode"]),
  setup(__props: any, { emit: __emit }) {



const props = __props
const emit = __emit

const searchModel = _useModel(__props, 'search')
const cardViewModel = _useModel(__props, 'cardViewMode')

const isSearchOpen = ref(false)

const isFiltersDialogOpen: Ref<boolean> = ref(false)
const appliedFilters: Ref<IFilterObj[]> = ref([])
const filtersComponent: Ref<ILandingListFiltersComponent | null> = ref(null)

if (searchModel.value) isSearchOpen.value = true

function toggleSearch() {
  if (props.disable || searchModel.value) return
  isSearchOpen.value = !isSearchOpen.value
}

function toggleCardViewMode(value: boolean) {
  cardViewModel.value = value
}

function onFilterUpdate(filterObj: IFilterData) {
  emit('filter', filterObj.model)
  isFiltersDialogOpen.value = false
  appliedFilters.value = filterObj.applied
}

function resetFilters() {
  filtersComponent.value?.resetFilters()
}

return (_ctx: any,_cache: any) => {
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_k_circle_icon = _resolveComponent("k-circle-icon")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_status = _resolveComponent("k-status")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["LandingListHeader q-pt-20 q-pt-md-lg flex column gap-md row-md items-center justify-between", [__props.rootClass, appliedFilters.value.length ? 'q-mb-sm' : 'q-pb-20', { reverse: _ctx.$q.screen.lt.md }]])
    }, [
      _renderSlot(_ctx.$slots, "create-action", {}, () => [
        _createVNode(_component_k_btn, _mergeProps({
          size: "md",
          icon: "plus-rounded",
          class: { 'full-width': _ctx.$q.screen.lt.md },
          "icon-size": "32px",
          label: __props.label,
          padding: "8px 20px 8px 8px",
          "is-right-icon": true
        }, _ctx.$attrs), null, 16 /* FULL_PROPS */, ["class", "label"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center gap-md gap-md-20", { 'full-width': _ctx.$q.screen.lt.md }])
      }, [
        _renderSlot(_ctx.$slots, "action-buttons", {}, () => [
          (__props.hasSearch)
            ? (_openBlock(), _createBlock(_component_k_input, {
                key: 0,
                modelValue: searchModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchModel).value = $event)),
                class: _normalizeClass(["LandingListHeader__search", {
            'LandingListHeader__search-inactive': !isSearchOpen.value && _ctx.$q.screen.gt.sm,
            'full-width': _ctx.$q.screen.lt.md,
          }]),
                "root-class": { 'flex-1': _ctx.$q.screen.lt.md },
                placeholder: "Search...",
                debounce: "1000"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_k_icon, {
                    size: "24px",
                    name: "search",
                    color: !__props.disable ? 'cool-gray-70' : 'cool-gray-60',
                    class: _normalizeClass({ 'cursor-pointer': !__props.disable }),
                    hoverable: !__props.disable,
                    onClick: toggleSearch
                  }, null, 8 /* PROPS */, ["color", "class", "hoverable"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "class", "root-class"]))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, "action-btn")
        ]),
        (__props.hasViewMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_q_separator, {
                vertical: "",
                size: "2px",
                color: "cool-gray-30",
                class: "q-my-sm"
              }),
              _createVNode(_component_k_btn, {
                model: "link",
                "custom-color": !__props.disable ? (!__props.cardViewMode ? 'cool-gray-100' : 'cool-gray-70') : 'cool-gray-60',
                icon: "menu-rectangle",
                disabled: __props.disable,
                "data-testid": "landing-list-header-table-view",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleCardViewMode(false)))
              }, null, 8 /* PROPS */, ["custom-color", "disabled"]),
              _createVNode(_component_k_btn, {
                model: "link",
                "custom-color": !__props.disable ? (__props.cardViewMode ? 'cool-gray-100' : 'cool-gray-70') : 'cool-gray-60',
                icon: "menu-square",
                disabled: __props.disable,
                "data-testid": "landing-list-header-card-view",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleCardViewMode(true)))
              }, null, 8 /* PROPS */, ["custom-color", "disabled"])
            ]))
          : _createCommentVNode("v-if", true),
        (__props.hasFilter)
          ? (_openBlock(), _createBlock(_component_q_separator, {
              key: 1,
              vertical: "",
              size: "2px",
              color: "cool-gray-30",
              class: "q-my-sm"
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" :disable=\"disable\" "),
        _createCommentVNode(" :disabled=\"disable\" "),
        _renderSlot(_ctx.$slots, "filter-actions"),
        (__props.hasFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_k_circle_icon, {
                name: "filters",
                size: "24px",
                color: "cool-gray-70",
                "root-class": "q-pa-sm cursor-pointer",
                "is-hover": "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (isFiltersDialogOpen.value = true))
              }),
              (appliedFilters.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(appliedFilters.value.length), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.$slots['extra-actions'])
          ? (_openBlock(), _createBlock(_component_q_separator, {
              key: 3,
              vertical: "",
              size: "2px",
              color: "cool-gray-30",
              class: "q-my-sm"
            }))
          : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "extra-actions")
      ], 2 /* CLASS */),
      _createVNode(LandingListFilters, {
        ref_key: "filtersComponent",
        ref: filtersComponent,
        modelValue: isFiltersDialogOpen.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isFiltersDialogOpen).value = $event)),
        "filter-model": __props.filterModel,
        filters: __props.filters,
        onApply: onFilterUpdate
      }, null, 8 /* PROPS */, ["modelValue", "filter-model", "filters"])
    ], 2 /* CLASS */),
    (appliedFilters.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_k_divider, {
            size: "md",
            class: "q-my-sm"
          }),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fs-13px fw-500 text-space-b-100" }, "Filtered By:", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedFilters.value, (appliedFilter, index) => {
                return (_openBlock(), _createBlock(_component_k_status, {
                  key: index,
                  hoverless: "",
                  color: "cool-gray-30",
                  "border-color": "cool-gray-40",
                  clearable: true,
                  onCleared: ($event: any) => (filtersComponent.value?.resetFilterByKey(appliedFilter.key))
                }, {
                  default: _withCtx(() => [
                    (appliedFilter.label)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(appliedFilter.label) + ": ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(appliedFilter.value), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onCleared"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createVNode(_component_k_btn, {
              model: "link",
              icon: "trash",
              "custom-color": "error-70",
              "icon-size": "20px",
              onClick: resetFilters
            })
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})